import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { IDefaultGDDT, IDefaultDataAddGDDT, IDefaultDataUpdateGD } from '../models/defaultGD';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GestionDispositivosDeviceToolsService {
  private apiUrl: string ='';
  constructor(private http: HttpClient) {
    this.apiUrl = environment.sUrlGd + 'device/tool';
  }

  getListadoHerramientas(): Observable<IDefaultGDDT> {
    return this.http
      .get<IDefaultGDDT>(this.apiUrl)
      .pipe(retry(1), catchError(this.handleError));
  }

  public editHerramienta(data: IDefaultDataUpdateGD ):Observable<IDefaultGDDT>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.put<any>(this.apiUrl, body,{'headers':headers});
   }

   public desactivarHerramienta(data: IDefaultDataUpdateGD ):Observable<IDefaultGDDT>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.put<any>(this.apiUrl + '/disable', body,{'headers':headers});
   }

   public saveHerramienta(data: IDefaultDataAddGDDT ):Observable<IDefaultGDDT>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl, body,{'headers':headers});
   }

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
